import { render } from "./egresosRenta.vue?vue&type=template&id=6533a86c&scoped=true"
import script from "./egresosRenta.vue?vue&type=script&lang=js"
export * from "./egresosRenta.vue?vue&type=script&lang=js"

import "./egresosRenta.vue?vue&type=style&index=0&id=6533a86c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6533a86c"]])

export default __exports__